import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPayloadCreator } from "util/api";
import { selectAuthToken } from "redux/features/auth";
import { RESOURCE_TYPE_PARTICIPATION } from "redux/typeConstants";

import { handleExternallyLoadedProfileResource } from "redux/features/profileResources";

const apiCall = createAsyncThunk(
  "nonPaymentRegistration/apiCall",
  apiPayloadCreator(
    "/non-payment-registrations",
    "post",
    (success, arg, thunkAPI) => {
      const { personId } = arg;
      if (success.participations)
        success.participations.forEach((participation) => {
          handleExternallyLoadedProfileResource({
            data: participation,
            resourceType: RESOURCE_TYPE_PARTICIPATION,
            resourceId: `${personId}/${participation.activity.id}`,
            personId,
            dispatch: thunkAPI.dispatch,
          });
        });
      return success;
    }
  )
);

const initialState = {
  instanceId: 0,
  personId: null,
  pending: false,
  error: null,
  data: null,
};

export const nonPaymentRegistrationSlice = createSlice({
  name: "paymentProcessing",
  initialState: initialState,
  reducers: {
    clear: (state) => {
      state.instanceId = state.instanceId + 1;
      state.personId = null;
      state.pending = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: {
    [apiCall.pending]: (state, action) => {
      const { arg } = action.meta;
      const { personId, instanceId } = arg;
      state.instanceId = instanceId;
      state.personId = personId;
      state.pending = true;
      state.error = null;
      state.data = null;
    },
    [apiCall.fulfilled]: (state, action) => {
      const { arg } = action.meta;

      // Discard stale responses
      if (state.instanceId !== arg.instanceId) return;
      if (state.personId !== arg.personId) return;

      state.pending = false;
      state.error = null;
      state.data = action.payload;
    },

    [apiCall.rejected]: (state, action) => {
      const { arg } = action.meta;

      // Discard stale responses
      if (state.instanceId !== arg.instanceId) return;
      if (state.personId !== arg.personId) return;

      state.error = action.payload;
      state.pending = false;
      state.data = null;
    },
  },
});

nonPaymentRegistrationSlice.selector = (store) => store.nonPaymentRegistration;

nonPaymentRegistrationSlice.asyncActions = {
  submit: (personId, instanceId, data) => (dispatch, getState) => {
    dispatch(
      apiCall({
        selectAuthToken,
        data,
        personId,
        instanceId,
        path: "/" + personId,
      })
    );
  },
};

export default nonPaymentRegistrationSlice.reducer;
